import React, { useEffect, useState } from "react";
import styles from "./MercadoDeTrabajo.module.scss";
import { connect } from "react-redux";
import { ReactComponent as Faq } from "../../assets/svg/FAQ.svg";
import { openTutorialModal, getAllWorkBagUsers } from "../../store/actions";
import WorkersMaps from "../UI/Maps/WorkersMaps"
import { ReactComponent as PhoneIcon } from "../../assets/svg/phoneIcon.svg";
import { ReactComponent as EmailIcon } from "../../assets/svg/mailIcon.svg";
import { ReactComponent as LocationIcon } from "../../assets/svg/employmentZoneIcon.svg";
import { ReactComponent as WorkIcon } from "../../assets/svg/trabajadoresIcon.svg";
import { ReactComponent as NoProfileIcon } from "../../assets/svg/noProfileIcon.svg";
import FilterWorkBag from "../Dashboard/FilterBy/FilterWorkBag/FilterWorkBag";
import Botonera from "../Botonera/Botonera";


const MercadoDeTrabajo = ({
    openTutorialModal,
    getAllWorkBagUsers,
    workBagUsers
}) => {
    const [ocultarEnMobile, setOcultarEnMobile] = useState(false);
    const [mobileStylesFromParent, setMobileStylesFromParent] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isFiltered, setIsFiltered] = useState(false);
    const [filterParamsForChildren, setFilterParamsForChildren] = useState(null);
    const [zoom, setZoom] = useState(3);
    const [center, setCenter] = useState([-34.61315, -58.37723]);
    const [loading, setLoading] = useState(true);
    const [coordinatesArray, setCoordinatesArray] = useState([]);
    const [selectedOptionJurisdictions, setSelectedOptionJurisdictions] = useState([]);
    const [selectedOptionSkills, setSelectedOptionSkills] = useState([]);

    const handleResize = () => {
        const windowWidth = window.innerWidth;
        setOcultarEnMobile(windowWidth < 768);
        setMobileStylesFromParent(windowWidth < 768);
    };

    useEffect(() => {
        getAllWorkBagUsers();
        handleResize();
    }, []);

    // Agregar un event listener para el cambio de tamaño de la ventana
    useEffect(() => {
        window.addEventListener("resize", handleResize);

        // Limpiar el event listener al desmontar el componente
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const formatDate = (date) => {
        const utcDate = new Date(date);
        const year = utcDate.getUTCFullYear();
        const month = utcDate.getUTCMonth() + 1;
        const day = utcDate.getUTCDate();
        return `${day}/${month}/${year}`;
    };

    const handleCloseInfo = () => {
        setZoom(3);
        setCenter([-38.416097, -63.616672]);
        setIsFiltered(false);
        setSelectedUser(null);
        setSelectedOptionJurisdictions([]);
        setSelectedOptionSkills([]);
    }

    return (
        <main className={styles.container}>
            {ocultarEnMobile && <Botonera mobileStylesFromParent={mobileStylesFromParent} />}
            <section className={styles.componentContainer}>
                <section className={styles.filterContainer}>
                    <FilterWorkBag
                        workBagUsers={workBagUsers}
                        setIsFiltered={setIsFiltered}
                        setZoom={setZoom}
                        setCenter={setCenter}
                        setCoordinatesArray={setCoordinatesArray}
                        setLoading={setLoading}
                        loading={loading}
                        coordinatesArray={coordinatesArray}
                        zoom={zoom}
                        center={center}
                        setSelectedUser={setSelectedUser}
                        selectedOptionJurisdictions={selectedOptionJurisdictions}
                        setSelectedOptionJurisdictions={setSelectedOptionJurisdictions}
                        selectedOptionSkills={selectedOptionSkills}
                        setSelectedOptionSkills={setSelectedOptionSkills}
                        setFilterParamsForChildren={setFilterParamsForChildren} />
                </section>
                <div className={styles.listContainer}>
                    <section className={styles.mapContainer}>
                        <WorkersMaps
                            ciudadesArray={workBagUsers}
                            setSelectedUser={setSelectedUser}
                            setIsFiltered={setIsFiltered}
                            isFiltered={isFiltered}
                            setZoom={setZoom}
                            setCenter={setCenter}
                            setCoordinatesArray={setCoordinatesArray}
                            setLoading={setLoading}
                            loading={loading}
                            coordinatesArray={coordinatesArray}
                            zoom={zoom}
                            center={center}
                            filterParamsForChildren={filterParamsForChildren} />
                            {selectedUser && !isFiltered && (
                        <section className={styles.selectedUser}>
                            <h2 className={styles.selectedUser_title}>Información {selectedUser.length > 1 ? "de los trabajadores" : "del trabajador"}
                            <button onClick={() => handleCloseInfo()} className={styles.selectedUser_title_closeButton}>X</button>
                            </h2>
                            <div className={styles.selectedUser_info}>
                                {selectedUser.map(user => (
                                    <div className={styles.selectedUser_infoTextList} key={user.id}>
                                        <h3 className={styles.selectedUser_name}>{user.name + " " + user.last_name}</h3>
                                        <div className={styles.selectedUser_infoText}><PhoneIcon width={20} height={20} />{user.phone}</div>
                                        <div className={styles.selectedUser_infoText}><EmailIcon width={20} height={20} />{user.email}</div>
                                        <div className={styles.selectedUser_infoText_zone}>
                                            <div className={styles.selectedUser_infoText_svgContainer}>
                                                <LocationIcon width={20} height={20} />
                                            </div>
                                            <div className={styles.selectedUser_infoText_zoneContainer}>

                                                {user.jobBoardZones.map(zone => zone.city).join(", ")}
                                            </div>
                                        </div>
                                        <div className={styles.selectedUser_infoText}>
                                            <div className={styles.selectedUser_infoText_svgContainer}>
                                                <WorkIcon width={20} height={20} />
                                            </div>
                                            {user.skill.map(skill => skill.skill?.name).join(", ")}</div>
                                        <div className={styles.selectedUser_infoText}>{user.unemployment_fund ? "Posee libreta de desempleo" : "No posee libreta de desempleo"}</div>
                                        <div className={styles.selectedUser_infoText}>{user.current_job ? `Se encuentra actualmente con trabajo hasta el ${formatDate(user.employment_end_date)}` :
                                            "Disponible para trabajar"} </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}
                    </section>                   
                    {isFiltered && (
                        <section className={styles.selectedUser}>
                            <h2 className={styles.selectedUser_title}>Información {workBagUsers.length > 1 ? "de los trabajadores" : "del trabajador"}
                            <button onClick={() => handleCloseInfo()} className={styles.selectedUser_title_closeButton}>X</button>
                            </h2>
                            <div className={styles.selectedUser_info}>
                                {workBagUsers.length >= 1 ? workBagUsers.map(user => (
                                    <div className={styles.selectedUser_infoTextList} key={user.id}>
                                        <h3 className={styles.selectedUser_name}>{user.name + " " + user.last_name}</h3>
                                        <div className={styles.selectedUser_infoText}><PhoneIcon width={20} height={20} />{user.phone}</div>
                                        <div className={styles.selectedUser_infoText}><EmailIcon width={20} height={20} />{user.email}</div>
                                        <div className={styles.selectedUser_infoText_zone}>
                                            <div className={styles.selectedUser_infoText_svgContainer}>
                                                <LocationIcon width={20} height={20} />
                                            </div>
                                            <div className={styles.selectedUser_infoText_zoneContainer}>

                                                {user.jobBoardZones.map(zone => zone.city).join(", ")}
                                            </div>
                                        </div>
                                        <div className={styles.selectedUser_infoText}>
                                            <div className={styles.selectedUser_infoText_svgContainer}>
                                                <WorkIcon width={20} height={20} />
                                            </div>
                                            {user.skill.map(skill => skill.skill?.name).join(", ")}</div>
                                        <div className={styles.selectedUser_infoText}>{user.unemployment_fund ? "Posee libreta de desempleo" : "No posee libreta de desempleo"}</div>
                                        <div className={styles.selectedUser_infoText}>{user.current_job ? `Se encuentra actualmente con trabajo hasta el ${formatDate(user.employment_end_date)}` :
                                            "Disponible para trabajar"} </div>
                                    </div>
                                )) : (
                                    <div className={styles.selectedUser_emptyList}>
                                        <NoProfileIcon width={70} height={70} />
                                        <h3 className={styles.selectedUser_emptyList_text}>No hay trabajadores que cumplan con los criterios de búsqueda</h3>
                                    </div>
                                )}

                            </div>
                        </section>
                    )}
                </div>
            </section>
        </main>
    );
}

const mapStateToProps = (state) => {
    return {
        workBagUsers: state.register.workBagUsers
    };
}

export default connect(mapStateToProps, { openTutorialModal, getAllWorkBagUsers })(MercadoDeTrabajo);
